/* tslint:disable */
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackFilter,  } from '../../models/BaseModels';
import { JSONSearchParams } from '../core/search.params';
import { ErrorHandler } from '../core/error.service';
import { Observable, Subject } from 'rxjs';
import { ViewPoIntegMySuporte } from '../../models/ViewPoIntegMySuporte';


/**
 * Api services for the `ViewPoIntegMySuporte` model.
 */

export class ViewPoIntegMySuporteApi extends BaseLoopBackApi {

  constructor(
     
  ) {
    
    super();
    
  }



  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewPoIntegMySuporte`.
   */
  getModelName() {
    return "ViewPoIntegMySuporte";
  }
}




// WEBPACK FOOTER //
// ./src/sdk/services/custom/ViewPoIntegMySuporte.js